export default {"src":"/_next/static/media/arrow-left.4ad24428.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};